<template>
  <div class="party-study-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('partyStudy.list.title') }}</span>
        <el-button type="primary" size="small" @click="_openAddDialog">
          <i class="el-icon-plus"></i>{{ $t('common.add') }}
        </el-button>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-input v-model="conditions.title" :placeholder="$t('partyStudy.search.title')" />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_queryMethod()">{{ $t('common.search') }}</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top:20px">
      <el-table :data="studys" border style="width:100%" v-loading="loading">
        <el-table-column prop="title" :label="$t('partyStudy.table.title')" align="center" />
        <el-table-column :label="$t('partyStudy.table.coverUrl')" align="center" width="120">
          <template slot-scope="scope">
            <el-image v-if="scope.row.coverUrl" :src="scope.row.coverUrl" style="width:60px;height:60px" fit="cover" :preview-src-list="[scope.row.coverUrl]" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" :label="$t('common.createTime')" align="center" />
        <el-table-column :label="$t('common.operation')" align="center" width="200">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="_openEditDialog(scope.row)">{{ $t('common.edit') }}</el-button>
              <el-button size="mini" type="danger" @click="_deleteStudy(scope.row)">{{ $t('common.delete') }}</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:15px" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper" :total="page.total" />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" @close="_resetForm">
      <el-form :model="studyForm" :rules="formRules" ref="studyFormRef" label-width="100px">
        <el-form-item :label="$t('partyStudy.form.title')" prop="title">
          <el-input v-model="studyForm.title" :placeholder="$t('partyStudy.form.titlePlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('partyStudy.form.coverUrl')" prop="coverUrl">
          <el-upload
            action=""
            :show-file-list="false"
            :before-upload="beforeUpload"
            :http-request="handleUpload"
          >
            <img v-if="studyForm.coverUrl" :src="studyForm.coverUrl" style="width:100px;height:100px;object-fit:cover" />
            <div v-else class="upload-btn">
              <i class="el-icon-plus"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="$t('partyStudy.form.content')" prop="content">
          <el-input v-model="studyForm.content" type="textarea" :rows="6" :placeholder="$t('partyStudy.form.contentPlaceholder')" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="_submitForm">{{ $t('common.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPartyStudys, savePartyStudy, updatePartyStudy, getPartyStudy } from '@/api/party/partyStudyApi'
import { uploadFile } from '@/api/admin/advertManageApi'

export default {
  name: 'PartyStudyList',
  data() {
    return {
      loading: false,
      studys: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      conditions: {
        title: ''
      },
      dialogVisible: false,
      isEdit: false,
      studyForm: {
        studyId: '',
        title: '',
        coverUrl: '',
        content: ''
      },
      formRules: {
        title: [{ required: true, message: this.$t('partyStudy.form.titleRequired'), trigger: 'blur' }],
        coverUrl: [{ required: true, message: '请上传封面图', trigger: 'change' }],
        content: [{ required: true, message: this.$t('partyStudy.form.contentRequired'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('partyStudy.form.editTitle') : this.$t('partyStudy.form.addTitle')
    }
  },
  created() {
    this._listStudys()
  },
  methods: {
    async _listStudys() {
      try {
        this.loading = true
        const params = {
          ...this.conditions,
          page: this.page.current,
          row: this.page.size
        }
        const { data, total } = await listPartyStudys(params)
        this.studys = data || []
        this.page.total = total || 0
      } catch (error) {
        this.$message.error(this.$t('partyStudy.fetchError'))
      } finally {
        this.loading = false
      }
    },
    _queryMethod() {
      this.page.current = 1
      this._listStudys()
    },
    _openAddDialog() {
      this.isEdit = false
      this._resetForm()
      this.dialogVisible = true
    },
    async _openEditDialog(row) {
      this.isEdit = true
      try {
        const res = await getPartyStudy({ studyId: row.studyId })
        const data = res.data
        if (data) {
          // 后端返回data可能是数组，取第一个元素
          const item = Array.isArray(data) ? data[0] : data
          if (item) {
            this.studyForm = { ...this.studyForm, ...item }
          }
        }
        this.dialogVisible = true
      } catch (error) {
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    _deleteStudy(row) {
      this.$confirm(this.$t('common.deleteConfirm'), this.$t('common.warning'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(async () => {
        try {
          await updatePartyStudy({ studyId: row.studyId, statusCd: '0' })
          this.$message.success(this.$t('common.deleteSuccess'))
          this._listStudys()
        } catch (error) {
          this.$message.error(this.$t('common.operationFailed'))
        }
      }).catch(() => {})
    },
    _resetForm() {
      this.studyForm = {
        studyId: '',
        title: '',
        coverUrl: '',
        content: ''
      }
      if (this.$refs.studyFormRef) {
        this.$refs.studyFormRef.clearValidate()
      }
    },
    _submitForm() {
      this.$refs.studyFormRef.validate(async (valid) => {
        if (!valid) return
        if (!this.studyForm.coverUrl) {
          this.$message.warning('请上传封面图')
          return
        }
        try {
          if (this.isEdit) {
            await updatePartyStudy(this.studyForm)
          } else {
            await savePartyStudy(this.studyForm)
          }
          this.$message.success(this.$t('common.operationSuccess'))
          this.dialogVisible = false
          this._listStudys()
        } catch (error) {
          this.$message.error(this.$t('common.operationFailed'))
        }
      })
    },
    beforeUpload(file) {
      const isImage = file.type.includes('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error(this.$t('common.jpgOnly'))
      }
      if (!isLt10M) {
        this.$message.error(this.$t('common.sizeLimit'))
      }
      return isImage && isLt10M
    },
    async handleUpload({ file }) {
      try {
        const formData = new FormData()
        formData.append('uploadFile', file)
        const url = await uploadFile(formData)
        this.studyForm.coverUrl = url
      } catch (error) {
        this.$message.error(this.$t('common.operationFailed'))
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listStudys()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listStudys()
    }
  }
}
</script>

<style lang="scss" scoped>
.party-study-container {
  padding: 20px;

  .upload-btn {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    background-color: #fbfdff;

    &:hover {
      border-color: #409eff;
    }

    i {
      font-size: 28px;
      color: #8c939d;
    }
  }
}
</style>
